var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageComponent)?_c(_vm.pageComponent,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }